import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import clearString from '~/prix/utils/bulk/clearString'
import { parseEnumEmptyString, parseStringArray } from '~/prix/utils/bulk/csvValueParsers'

const dentalClinicalEvolution: Dataset = {
  schema: 'public_health',
  table: 'dental_clinical_evolution',
  columnTransformMap: {
    original_id: original => clearString(original as string),
    data_source_id: original => original,
    dental_attendance_original_id: original => clearString(original as string),
    oral_part_detailed: original => clearString(original as string),
    oral_part: original => parseEnumEmptyString(original as string),
    evolution_description: original => clearString(original as string),
    sigtap_code: original => parseStringArray(original as string),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default dentalClinicalEvolution
